import Awesomplete from "awesomplete";
import jQuery from "jquery";

export default class autocomplete {
  constructor(element) {
    let self = this;

    this.inputElement = element.querySelector("input[type=search]");
    this.url = this.inputElement.getAttribute("data-url");
    let type = this.inputElement.getAttribute("data-type");
    this.formId = element.getAttribute("data-form");

    let config = {
      minChars: 2,
      list: [],
    };

    // preparation
    switch (type) {
      case "ajax":
        if (!this.url) return FALSE;
        break;
      case "lookup_company":
        // the filter is because we want to display all results,
        // the eniro api does the filtering
        config = {
          minChars: 4,
          list: [],
          filter: function (x, y) {
            return true;
          },
        };
        break;
      default:
        let scriptElement = element.querySelector("script");
        if (scriptElement != null && scriptElement.innerHTML !== "") {
          config = {
            minChars: 2,
            list: JSON.parse(scriptElement.innerHTML),
          };
        }
    }

    // initialization
    this.autocomplete = new Awesomplete(self.inputElement, config);

    // execution
    switch (type) {
      case "ajax":
        this.ajax();
        break;
      case "lookup_company":
        /*this.inputElement.outerHTML = this.inputElement.outerHTML + '<a id="lookup_company_button" href="#" class="a-btn">Sök</a>';
      jQuery('#lookup_company_button').click(function() {
        self.value = jQuery('#edit-sok-efter-din-arbetsgivare').val();
        if (self.value.length > 3) {

          jQuery.ajax({
            url: '/lookup_company/' + self.value,
            dataType: 'json',
            success: function(data) {
              console.log(data);
            },
          });
        }
        return false;
      });
      jQuery(self.inputElement).on('awesomplete-selectcomplete', function(e) {
        let value = e.currentTarget.value;
        let values = value.split('|');
        e.currentTarget.value = values[0];
        */

        /*jQuery('#companyorgnumber').val(values[1])
        jQuery('#companystreetname').val(values[2])
        jQuery('#companypostcode').val(values[3])
        jQuery('#companycity').val(values[4])
        if (values[5]) {
          let establishments = JSON.parse(values[5]);
          jQuery('#edit-valj-din-kontor').empty()
          jQuery.each(establishments, function(key, value) {
            jQuery('#edit-valj-din-kontor')
              .append(jQuery('<option>', {
                value: value.companyEstablishmentNumber
              })
                .text(value.establishmentOfficeName + ' (' + value.establishmentTown + ')'));
          });
          jQuery('.js-form-item-valj-din-kontor').removeClass('u-visually-hidden');
        } else {
          jQuery('.js-form-item-valj-din-kontor').addClass('u-visually-hidden');
        }*/
        //});
        //this.lookup_company(this.autocomplete)
        break;
      case "open":
        this.open();
        break;
    }
  }

  open() {
    let self = this;
    this.inputElement.addEventListener("focus", function () {
      self.autocomplete.evaluate();
    });
  }

  ajax() {
    let self = this;
    this.inputElement.addEventListener("input", function () {
      if (this.value !== "" && this.value.length > 1) {
        let xhr = new XMLHttpRequest();
        xhr.open("GET", self.url + this.value);
        xhr.onreadystatechange = function () {
          if (xhr.readyState > 3 && xhr.status == 200) {
            self.ajaxDisplayresults(JSON.parse(xhr.response));
          }
        };
        xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
        xhr.send();
      }
    });

    jQuery(self.inputElement).on("awesomplete-selectcomplete", function (e) {
      jQuery(self.formId).submit();
    });
  }

  ajaxDisplayresults(list) {
    let self = this;
    let newList = [];
    list.forEach(function (obj) {
      newList.push(obj);
    });
    self.autocomplete.list = newList;
  }

  lookup_company(autocomplete) {
    let self = this;
    this.inputElement.addEventListener("input", function () {
      if (this.value.length > 1) {
        jQuery.ajax({
          url: "/lookup_company/" + this.value,
          dataType: "json",
          success: function ($data) {
            let newlist = [];
            for (let i = 0; i < $data.length; i++) {
              let $company = $data[i];
              newlist.push({
                label: $company.companyname,
                value:
                  $company.companyname +
                  "|" +
                  $company.orgnumber +
                  "|" +
                  $company.streetname +
                  "|" +
                  $company.postcode +
                  "|" +
                  $company.city +
                  "|" +
                  JSON.stringify($company.establishments.establishments),
              });
            }
            autocomplete.list = newlist;
          },
        });
      }
    });
  }
}
